<template>
  <div class="post">
    <v-snackbar
      v-model="isClosedStream"
      color="error"
      bottom
      :timeout="1000000"
    >
      配信は終了しました。
    </v-snackbar>

    <Confirm ref="confirm" />
    <Share ref="share" />

    <v-dialog
      v-model="selectDialog"
      max-width="500"
    >
      <v-card outlined>
        <v-card-title>
          <span>音源ダウンロード</span>
          <v-spacer />
          <v-btn
            fab
            text
            x-small
            @click="selectDialog = false"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <p class="ma-0">
            {{ soundId && $_musicalInstruments().info[soundId].text }}
            ({{ soundId && $_musicalInstruments().info[soundId].size }})のダウンロードを開始します。<br>
            (ページを移動してもダウンロードは継続されます。)
          </p>
          <v-row>
            <v-spacer />
            <v-col class="col-12 col-sm-6 pb-0">
              <v-btn
                block
                depressed
                color="secondary"
                @click="getSounds()"
              >
                確認
              </v-btn>
            </v-col>
            <v-spacer />
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col class="pa-0 pb-3">
        <v-card outlined>
          <v-card-text class="pa-2 pa-sm-3">
            <Keyboard
              :loaded-sound-size="loadedSoundSize"
              :action-virtual-key="actionVirtualKey"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="postDetails.playingTime">
      <v-col class="pa-0 pb-3">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-col class="control-box d-flex col-12 col-md-auto pa-0">
                <v-btn
                  depressed
                  small
                  :disabled="!isLoadedMidi || loadedSoundSize !== 88"
                  :loading="!isLoadedMidi"
                  color="white"
                  class="play-btn"
                  @click="playArchive(nowArchiveArrayIndex)"
                >
                  <v-icon
                    small
                    color="primary"
                  >
                    {{ isPlayPause ? 'fas fa-play' : 'fas fa-pause' }}
                  </v-icon>
                </v-btn>
                <v-divider vertical />
                <v-btn
                  depressed
                  tile
                  small
                  :disabled="!isLoadedMidi || loadedSoundSize !== 88"
                  color="white"
                  @click="stopArchive"
                >
                  <v-icon
                    small
                    color="primary"
                  >
                    fas fa-stop
                  </v-icon>
                </v-btn>
                <v-divider vertical />
                <v-btn
                  depressed
                  tile
                  small
                  :disabled="!isLoadedMidi || loadedSoundSize !== 88"
                  :color="isPlayLoop ? 'primary' : 'white'"
                  @click="isPlayLoop = !isPlayLoop"
                >
                  <v-icon
                    small
                    :color="isPlayLoop ? 'white' : 'primary'"
                  >
                    fas fa-retweet
                  </v-icon>
                </v-btn>
                <v-divider vertical />
                <v-spacer class="d-block d-sm-none" />
                <div class="d-flex align-center px-3">
                  <span>{{ $_convertPlayTime(nowPlayTime) }} / {{ $_convertPlayTime(postDetails.playingTime || 0) }}</span>
                </div>
                <v-spacer class="d-block d-sm-none" />
              </v-col>
              <v-spacer class="d-none d-md-block d-lg-none" />
              <v-col
                class="d-flex align-center col-12 col-md-7 col-lg-4 col-xl-5 py-3 py-md-0"
                @click="clickPlaySlider"
              >
                <v-slider
                  v-model="nowArchiveArrayIndex"
                  min="0"
                  :max="archiveArray.length || 100"
                  step="1"
                  hide-details
                  :readonly="!isPlayPause"
                  :disabled="!isLoadedMidi || loadedSoundSize !== 88"
                  append-icon="fa-step-forward"
                  prepend-icon="fa-step-backward"
                  class="volume-slider"
                  @click:append="addArchiveArrayIndex(100)"
                  @click:prepend="addArchiveArrayIndex(-100)"
                />
                <v-divider
                  vertical
                  class="d-none d-lg-block ml-3"
                />
              </v-col>
              <v-spacer class="d-none d-lg-block" />
              <v-col class="d-flex align-center col-12 col-sm-6 col-md-6 col-lg-2 pa-lg-0">
                <v-divider
                  vertical
                  class="d-none d-lg-block mr-3"
                />
                <v-select
                  v-model="soundId"
                  :items="$_musicalInstruments().selects"
                  :success="soundId && $_musicalInstruments().info[soundId].isLoaded"
                  :error="!soundId || !$_musicalInstruments().info[soundId].isLoaded"
                  :disabled="!postDetails.postId || isLoading.sounds"
                  :loading="isLoading.sounds"
                  label="楽器"
                  hide-details
                  outlined
                  dense
                  class="dense-select"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      :value="loadedSoundSize*100/88"
                      color="success"
                      absolute
                    />
                  </template>
                  <v-icon
                    v-if="soundId && !$_musicalInstruments().info[soundId].isLoaded"
                    slot="append"
                    :disabled="isLoading.sounds"
                    @click="selectDialog = true"
                  >
                    fa-download
                  </v-icon>
                </v-select>
              </v-col>
              <v-col class="d-flex align-center col-12 col-sm-6 col-md-6 col-lg-2 pa-md-0 pr-5 pr-md-5">
                <v-slider
                  v-model="volumeRatio"
                  min="0"
                  max="100"
                  thumb-label
                  hide-details
                  :disabled="!loadedSoundSize"
                  append-icon="fa-volume-up"
                  prepend-icon="fa-volume-down"
                  class="volume-slider ml-0 ml-md-3"
                  @click:append="volumeRatio += 10"
                  @click:prepend="volumeRatio -= 10"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="col-12 col-lg-6 pa-0 pb-3">
        <v-card outlined>
          <v-card-text class="pa-0">
            <v-row class="ma-0">
              <v-spacer class="d-none d-lg-block" />
              <v-col class="col-12 col-sm-6">
                <v-select
                  v-model="soundId"
                  :items="$_musicalInstruments().selects"
                  :success="soundId && $_musicalInstruments().info[soundId].isLoaded"
                  :error="!soundId || !$_musicalInstruments().info[soundId].isLoaded"
                  :disabled="!postDetails.postId || isLoading.sounds"
                  :loading="isLoading.sounds"
                  label="楽器"
                  hide-details
                  outlined
                  dense
                  class="dense-select"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      :value="loadedSoundSize*100/88"
                      color="success"
                      absolute
                    />
                  </template>
                  <v-icon
                    v-if="soundId && !$_musicalInstruments().info[soundId].isLoaded"
                    slot="append"
                    :disabled="isLoading.sounds"
                    @click="selectDialog = true"
                  >
                    fa-download
                  </v-icon>
                </v-select>
              </v-col>
              <v-col class="d-flex align-center col-12 col-sm-6">
                <v-slider
                  v-model="volumeRatio"
                  min="0"
                  max="100"
                  thumb-label
                  hide-details
                  :disabled="!loadedSoundSize"
                  append-icon="fa-volume-up"
                  prepend-icon="fa-volume-down"
                  class="volume-slider ml-0 ml-md-3"
                  @click:append="volumeRatio += 10"
                  @click:prepend="volumeRatio -= 10"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12 col-sm-6 pa-0">
        <v-card outlined>
          <v-skeleton-loader
            v-if="isLoading.post"
            type="article"
            tile
            max-width="900"
          />
          <v-card-text v-else-if="!postDetails.postId">
            投稿が存在しません。
          </v-card-text>
          <template v-else>
            <v-card-title class="pb-0">
              <span>{{ postDetails.title }}</span>
            </v-card-title>
            <v-card-text>
              <v-row class="ma-0">
                <v-col class="d-block px-0 py-1 col-12 col-lg-auto">
                  <div class="d-flex align-center">
                    <v-icon
                      small
                      class="ml-0 mr-2"
                    >
                      fas fa-headphones-alt
                    </v-icon>
                    <span>{{ $_convertNumFormat(postDetails.playCount) }} 回再生</span>
                  </div>
                  <span v-if="postDetails.mode === 'stream'">
                    {{ $_convertDateFormat(postDetails.createdAt, !postDetails.playingTime) }} にライブ配信
                  </span>
                  <span v-else>
                    {{ $_convertDateFormat(postDetails.createdAt) }} にアップロード
                  </span>
                </v-col>
                <v-spacer class="d-none d-lg-block" />
                <v-col class="pa-0">
                  <v-btn
                    block
                    tile
                    text
                    height="52"
                    :color="postDetails.isFavorite ? 'primary' : 'secondary'"
                    :disabled="$_myUserData.isLoaded && !$_myUserData.isAuthed"
                    @click="doFavPost"
                  >
                    <div>
                      <v-icon size="17">
                        {{ postDetails.isFavorite ? 'fas' : 'far' }} fa-star
                      </v-icon>
                      <div>{{ $_convertNumFormat(postDetails.favCount) }}</div>
                    </div>
                  </v-btn>
                </v-col>
                <v-col class="pa-0">
                  <v-btn
                    block
                    tile
                    text
                    height="52"
                    color="secondary"
                    @click="sharePost"
                  >
                    <div>
                      <v-icon size="17">
                        fas fa-share-square
                      </v-icon>
                      <div>共有</div>
                    </div>
                  </v-btn>
                </v-col>
                <v-col
                  v-if="postDetails.uid === $_myUserData.uid"
                  class="pa-0"
                >
                  <v-btn
                    block
                    tile
                    text
                    height="52"
                    color="error"
                    @click="deletePost"
                  >
                    <div>
                      <v-icon size="17">
                        far fa-trash-alt
                      </v-icon>
                      <div>削除</div>
                    </div>
                  </v-btn>
                </v-col>
              </v-row>
              <v-divider class="pb-3" />
              <div class="d-flex">
                <v-btn
                  fab
                  text
                  small
                  :ripple="false"
                  :to="{ name: 'user-page', params: { userId: postDetails.uid } }"
                  class="not-hover-btn mr-3"
                >
                  <v-avatar
                    size="40"
                    color="grey lighten-4"
                  >
                    <v-img
                      v-if="postDetails.photoURL"
                      :src="postDetails.photoURL"
                    />
                    <v-icon
                      v-else
                      size="20"
                    >
                      fa-user
                    </v-icon>
                  </v-avatar>
                </v-btn>
                <div class="user-box">
                  <v-btn
                    text
                    :ripple="false"
                    min-width="20"
                    :to="{ name: 'user-page', params: { userId: postDetails.uid } }"
                    class="not-hover-btn pa-0 justify-start"
                  >
                    <span>{{ postDetails.displayName }}</span>
                  </v-btn>
                </div>
              </div>
              <div class="d-flex mt-3">
                <div
                  class="d-none d-sm-block mr-3"
                  style="width: 40px;"
                />
                <div>
                  <p
                    class="mb-0"
                    style="white-space: pre-line;"
                  >
                    {{ postDetails.explanation }}
                  </p>
                </div>
              </div>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
      <v-col
        v-if="postDetails.postId && !postDetails.playingTime"
        class="col-12 col-sm-6 pa-0 pt-3 pt-sm-0 pl-sm-3"
      >
        <v-row class="ma-0">
          <v-col class="col-12 col-xl-6 pa-0 pb-3">
            <v-card outlined>
              <v-card-title>
                <span>受信設定</span>
                <v-tooltip
                  right
                  max-width="350"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-1"
                      v-on="on"
                    >
                      far fa-question-circle
                    </v-icon>
                  </template>
                  <p>
                    モードA：1000 ms間データを溜めてラグを緩和します。(推奨)
                  </p>
                  <p>
                    モードB：500 ms間データを溜めてラグを緩和します。特にラグを感じない時に選択してください。
                  </p>
                  <p class="mb-0">
                    モードC：受信したデータを即時に再生します。平均遅延時間のブレがなければ最小の遅延で再生が可能です。(非推奨)
                  </p>
                </v-tooltip>
                <v-spacer />
                <v-tooltip
                  left
                  max-width="350"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      :color="isOffline ? 'error' : 'success'"
                      v-on="on"
                    >
                      fas fa-circle
                    </v-icon>
                  </template>
                  <span>{{ isOffline ? 'オフライン' : 'オンライン' }}</span>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <p class="mb-2">
                  データを再生するモードを選択してください。<br>
                  途中で変更は可能ですが未再生のデータは破棄されます。
                </p>
                <v-row>
                  <v-col>
                    <v-btn-toggle
                      v-model="playMode"
                      mandatory
                      dense
                      color="primary"
                    >
                      <v-btn
                        v-for="i in 3"
                        :key="i"
                      >
                        モード{{ 'ABC'[i - 1] }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <v-row v-if="postDetails.uid === $_myUserData.uid">
                  <v-col>
                    <v-btn
                      depressed
                      color="success"
                      :to="{
                        name: 'stream',
                        params: {
                          postId: postDetails.postId
                        }
                      }"
                    >
                      配信再開
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="col-12 col-xl-6 pa-0 pl-xl-3">
            <v-card outlined>
              <v-card-title class="pb-2">
                <span>遅延情報</span>
                <v-tooltip
                  right
                  max-width="350"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      class="ml-1"
                      v-on="on"
                    >
                      far fa-question-circle
                    </v-icon>
                  </template>
                  <p>
                    「標準時刻との差」は受信を開始した時点で取得されます。
                    この値の大きさは再生の質には影響ありません。ただし、時間を取得できなかった場合は、
                    遅延の処理に問題が発生する可能性があります。
                  </p>
                  <p class="mb-0">
                    「平均遅延時間」は配信データを受信するのにかかった時間の平均です。
                    受信するユーザーの場所にもよりますが遅延時間の目安になります。
                  </p>
                </v-tooltip>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-text-field
                      label="標準時刻との差"
                      suffix="ms"
                      readonly
                      :disabled="!postDetails.postId"
                      hide-details
                      type="number"
                      :value="Math.floor(-ntpTimeDiff*10)/10"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="平均遅延時間"
                      suffix="ms"
                      readonly
                      :disabled="!postDetails.postId"
                      hide-details
                      type="number"
                      :value="Math.floor(avrDelay*10)/10"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
.post {
  > * {
    margin: auto;
  }
  .control-box {
    .v-btn {
      width: 54px !important;
      height: 54px !important;
    }
    .play-btn {
      border-radius: 3px 0px 0px 3px !important;
    }
  }
  .volume-slider {
    .v-icon::after {
      background-color: initial;
    }
  }
  .dense-select .v-icon {
    font-size: 17px;
    padding: 3px;
  }
  .user-box {
    width: calc(100% - 52px);

    a, span {
      max-width: 100%;
      white-space: pre-line;
    }
  }
}
</style>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';

export default {
  data: () => ({
    dbRefs: {},
    ntpTimeDiff: 0,
    isLoading: {
      sounds: false,
      post: false
    },
    soundId: null,
    loadedSoundSize: 0,
    noSoundFile: false,
    notes: new Map(),
    maxVolume: 0.3,
    volumeRatio: 30,
    isDamper: false,
    damperNotes: [],
    selectDialog: false,
    delay: 0,
    countGetMessage: 0,
    avrDelay: 0,
    playMode: 0,
    beforeTime: {
      received: 0,
      myself: 0
    },
    archiveArray: [],
    isPlayPause: true,
    isPlayLoop: false,
    nowArchiveArrayIndex: 0,
    playTimeoutIds: [],
    postDetails: {},
    notPost: false,
    isLoadedMidi: false,
    isOffline: true,
    isClosedStream: false
  }),
  computed: {
    mitigateDelayTime() {
      if (this.playMode === 0) {
        return 1000;
      } else if (this.playMode === 1) {
        return 500;
      } else {
        return undefined;
      }
    },
    nowPlayTime() {
      if (this.nowArchiveArrayIndex === this.archiveArray.length) {
        return this.postDetails.playingTime;
      }
      return (this.archiveArray[this.nowArchiveArrayIndex] || {}).time - (this.archiveArray[0] || {}).time;
    }
  },
  watch: {
    playMode() {
      this.resetDelay();
      const playTimeoutIds = [...this.playTimeoutIds];
      this.playTimeoutIds = [];
      playTimeoutIds.forEach(id => {
        clearTimeout(id);
      });
    },
    async soundId(val) {
      const selectedSoundInfo = this.$_musicalInstruments().info[val];
      this.loadedSoundSize = selectedSoundInfo.sounds.size;
      if (selectedSoundInfo.isLoaded) {
        this.loadedSoundSize = 0;
        for (let noteId = 21; noteId < 88 + 21; noteId++) {
          this.notes.set(noteId, {
            origSound: selectedSoundInfo.sounds.get(noteId),
            playNotes: []
          });
          this.loadedSoundSize++;
        }
        this.$_pushNotice('音源の読み込みが完了しました。', 'success');
        if (!this.postDetails.playingTime && !this.$store.state.firebaseState.isConnected) {
          await this.openStream();
        }
      } else {
        this.selectDialog = true;
      }
    }
  },
  async mounted() {
    firebase.database().goOnline();
    await this.getPostDetails();
  },
  destroyed() {
    this.onClosedStream();
    this.stopArchive();
  },
  methods: {
    async getPostDetails() {
      this.isLoading.post = true;
      try {
        const postRef = await firebase.firestore().collectionGroup('posts').where('postId', '==', this.$route.params.postId).get();
        if (postRef.empty) {
          throw new Error();
        }
        this.notPost = false;
        this.postDetails = {
          ...postRef.docs[0].data(),
          isFavorite: false
        };
        this.postDetails.postId = this.$route.params.postId;
        this.postDetails.createdAt = this.postDetails.createdAt.toDate();
        if (this.$_myUserData.uid) {
          const favPostDoc = await firebase.firestore()
            .collection('users').doc(this.$_myUserData.uid)
            .collection('favPosts').doc(this.$route.params.postId).get();
          this.postDetails.isFavorite = favPostDoc.exists;
        }
        this.$_createPageTitle({
          title: this.postDetails.title + ' - midies',
          desc: this.postDetails.explanation
        });
        this.isLoading.post = false;
        if (!this.postDetails.playingTime) {
          const postPath = `/users/${this.postDetails.uid}/posts/${this.postDetails.postId}`;
          this.dbRefs = {
            midi: firebase.database().ref(postPath + '/midi'),
            message: firebase.database().ref(postPath + '/message'),
            isOffline: firebase.database().ref(postPath + '/isOffline'),
            isClosed: firebase.database().ref(postPath + '/isClosed')
          };
          this.dbRefs.isOffline.on('value', snapshot => {
            this.isOffline = snapshot.exists();
          });
          this.dbRefs.isClosed.on('value', snapshot => {
            const data = snapshot.val();
            if (data) {
              this.onClosedStream();
              this.$_pushNotice('配信は終了しました。', 'error');
            }
          });
          return;
        }
        const postMidiRef = firebase.database().ref(`/users/${this.postDetails.uid}/posts/${this.postDetails.postId}/midi`);
        let beforeTime = null;
        const snapshot = await postMidiRef.once('value');
        if (!snapshot.exists()) {
          this.$_pushNotice('データのダウンロードに失敗しました。', 'error');
          throw new Error();
        }
        snapshot.forEach(childSnapshot => {
          const data = childSnapshot.val();
          const timeBuffer = data.time - (beforeTime || data.time);
          if (timeBuffer > 100) {
            const count = Math.round(timeBuffer/100) - 1;
            for (let i = 1; i <= count; i++) {
              this.archiveArray.push({
                signals: [],
                time: beforeTime + Math.floor(timeBuffer/count)*i
              });
            }
          }
          beforeTime = data.time;
          this.archiveArray.push(data);
        });
        this.$_pushNotice('データのダウンロードが完了しました。', 'success');
        this.isLoadedMidi = true;
        this.addPlayCount();
      } catch (err) {
        this.notPost = true;
        this.isLoading.post = false;
        console.error(err);
      }
    },
    async getSounds() {
      this.isLoading.sounds = true;
      this.selectDialog = false;
      const selectedSoundInfo = this.$_musicalInstruments().info[this.soundId];
      let beforeAbleNoteId = 21;
      for (let noteId = 21; !this.noSoundFile && noteId < 88 + 21; noteId++) {
        if (!selectedSoundInfo.sounds.has(noteId)) {
          const url = `/sounds/${this.soundId}/${noteId}.${selectedSoundInfo.extension}`;
          await new Promise((resolve, reject) => {
            const origSound = new Howl({ src: [url] });
            origSound.once('load', () => {
              this.$store.dispatch('setSoundData', {
                soundId: this.soundId,
                noteId,
                origSound
              });
              this.notes.set(noteId, { origSound, playNotes: [] });
              beforeAbleNoteId = noteId;
              resolve();
            });
            origSound.on('loaderror', () => {
              if (!beforeAbleNoteId) {
                reject();
              }
              this.$store.dispatch('setSoundData', {
                soundId: this.soundId,
                noteId,
                origSound: beforeAbleNoteId
              });
              this.notes.set(noteId, {
                origSound: beforeAbleNoteId,
                playNotes: []
              });
              resolve();
            });
          })
            .catch(() => {
              this.noSoundFile = true;
            });
        } else {
          this.notes.set(noteId, {
            origSound: selectedSoundInfo.sounds.get(noteId),
            playNotes: []
          });
        }
        this.loadedSoundSize++;
      }
      if (this.noSoundFile) {
        this.$_pushNotice('音源のダウンロードに失敗しました。', 'error');
        console.error('NO SOUND FILES');
      } else {
        this.$_pushNotice('音源のダウンロードが完了しました。', 'success');
      }
      this.isLoading.sounds = false;
      if (!this.postDetails.playingTime && !this.$store.state.firebaseState.isConnected) {
        await this.openStream();
      }
    },
    playMidi(notes, data, volumeRatio) {
      const note = notes.get(data[1]);
      if (!note) {
        return;
      }
      const keyDom = document.querySelectorAll('.keyboard > div')[data[1] - 21];
      if (data[0] === 144) {
        const volume = this.maxVolume*(Math.min(data[2], 127)/127)*(volumeRatio/100);
        if (typeof note.origSound !== 'number') {
          const sound = note.origSound.play();
          note.origSound.volume(volume, sound);
          note.playNotes.push({ sound, volume });
        } else {
          const beforeAbleSound = notes.get(note.origSound).origSound;
          const sound = beforeAbleSound.play();
          beforeAbleSound.rate(2**((data[1] - note.origSound)/12), sound);
          beforeAbleSound.volume(volume, sound);
          note.playNotes.push({ sound, volume });
        }
        if (keyDom) {
          keyDom.classList.add('key-active');
        }
      } else if (data[0] === 128) {
        if (this.isDamper) {
          this.damperNotes.push(data[1]);
        } else {
          for (const playNote of note.playNotes) {
            if (typeof note.origSound !== 'number') {
              note.origSound.fade(playNote.volume, 0, 300, playNote.sound);
            } else {
              notes.get(note.origSound).origSound.fade(playNote.volume, 0, 300, playNote.sound);
            }
          }
          note.playNotes = [];
        }
        if (keyDom) {
          keyDom.classList.remove('key-active');
        }
      } else if (data[0] === 176 && data[1] === 64) {
        if (data[2] > 0) {
          this.isDamper = true;
        } else {
          this.isDamper = false;
          for (const noteId of this.damperNotes) {
            const note = notes.get(noteId);
            for (const playNote of note.playNotes) {
              if (typeof note.origSound !== 'number') {
                note.origSound.fade(playNote.volume, 0, 300, playNote.sound);
              } else {
                notes.get(note.origSound).origSound.fade(playNote.volume, 0, 300, playNote.sound);
              }
            }
            note.playNotes = [];
          }
          this.damperNotes = [];
        }
      }
    },
    actionVirtualKey(noteId, isClick) {
      const data = [isClick ? 144 : 128, noteId, 64];
      const note = this.notes.get(noteId);
      if (!isClick && (!note || !note.playNotes.length)) {
        return;
      }
      this.playMidi(this.notes, data, this.volumeRatio);
    },
    onReceivedMidiSignals(data) {
      const nowTime = this.$_getNowTime(this.ntpTimeDiff);
      this.delay = nowTime - data.time;
      this.avrDelay = (this.avrDelay*this.countGetMessage + this.delay)/++this.countGetMessage;
      const diffTime = data.time - (this.beforeTime.received || data.time); // 前回からの時間差
      let timeBuffer = 0; // モードC
      if (this.playMode !== 2) { // モードA、B
        timeBuffer = this.mitigateDelayTime + diffTime - (nowTime - (this.beforeTime.myself || nowTime));
      }
      const recievedMidiSignals = data.signals;
      for (const midiSignal of recievedMidiSignals) {
        this.playTimeoutIds.push(
          setTimeout(() => {
            this.playMidi(this.notes, midiSignal.data, this.volumeRatio);
            this.playTimeoutIds.shift();
          }, midiSignal.delay + timeBuffer)
        );
      }
      this.beforeTime = {
        received: data.time,
        myself: this.$_getNowTime(this.ntpTimeDiff)
      };
    },
    async playArchive(startIndex = 0) {
      this.isPlayPause = !this.isPlayPause;
      if (this.isPlayPause) {
        this.stopArchive(false);
        return;
      }
      if (startIndex === this.archiveArray.length) {
        startIndex = 0;
      }
      this.nowArchiveArrayIndex = startIndex;
      let beforeTime = null;
      console.log('start:', startIndex);
      for (const midiData of this.archiveArray.slice(startIndex)) {
        const timeBuffer = midiData.time - (beforeTime || midiData.time);
        beforeTime = midiData.time;
        await this.$_sleep(timeBuffer);
        if (this.isPlayPause) {
          this.stopArchive(false);
          break;
        }
        this.nowArchiveArrayIndex++;
        for (const midiSignal of midiData.signals) {
          this.playTimeoutIds.push(
            setTimeout(() => {
              this.playMidi(this.notes, midiSignal.data, this.volumeRatio);
              this.playTimeoutIds.shift();
            }, midiSignal.delay)
          );
        }
        if (this.nowArchiveArrayIndex === this.archiveArray.length - 1) {
          this.playTimeoutIds.push(
            setTimeout(async() => {
              this.nowArchiveArrayIndex++;
              this.stopArchive(this.isPlayLoop);
              this.isDamper = false;
              if (this.isPlayLoop) {
                await this.$_sleep(100);
                this.playArchive();
              }
            }, (midiData.signals.slice(-1)[0] || {}).delay || 0)
          );
        }
      }
    },
    stopArchive(isStop = true) {
      console.log('stopArchive');
      if (isStop) {
        this.nowArchiveArrayIndex = 0;
      }
      this.isPlayPause = true;
      this.playTimeoutIds.forEach(id => {
        clearTimeout(id);
        this.playTimeoutIds.shift();
      });
      const beforeIsDamper = this.isDamper;
      this.isDamper = false;
      for (let noteId = 21; noteId < 88 + 21; noteId++) {
        this.playMidi(this.notes, [128, noteId, 64], this.volumeRatio);
      }
      if (!isStop && beforeIsDamper) {
        this.isDamper = true;
      }
    },
    clickPlaySlider() {
      if (!this.isPlayPause) {
        this.$_pushNotice('再生中はスライダーを使用できません。', 'error');
      }
    },
    async addArchiveArrayIndex(addIndex) {
      this.nowArchiveArrayIndex += addIndex;
      if (!this.isPlayPause) {
        this.stopArchive(false);
        await this.$_sleep(500);
        this.playArchive(this.nowArchiveArrayIndex);
      }
    },
    resetDelay() {
      this.delay = 0;
      this.countGetMessage = 0;
      this.avrDelay = 0;
    },
    async openStream() {
      const ntpTimeDiff = await this.$_getNtpTimeDiff();
      this.ntpTimeDiff = ntpTimeDiff || 0;
      console.log('NTP time diff:', ntpTimeDiff);
      if (ntpTimeDiff !== undefined) {
        this.$_pushNotice('NTPサーバと時間を同期しました。', 'success');
      } else {
        this.$_pushNotice('NTPサーバに接続できませんでした。', 'error');
      }
      this.dbRefs.midi.orderByChild('time').startAt(this.$_getNowTime(this.ntpTimeDiff)).on('child_added', snapshot => {
        const data = snapshot.val();
        this.onReceivedMidiSignals(data);
      });
      this.dbRefs.message.orderByChild('time').startAt(this.$_getNowTime(this.ntpTimeDiff)).on('child_added', snapshot => {
        const data = snapshot.val();
        this.$_pushNotice(data.text, data.type);
      });
      this.$store.dispatch('changeFirebaseState', true);
      window.addEventListener('beforeunload', this.$_beforeunloadHandler);
      this.$_pushNotice('データの受信を開始しました。', 'success');
      this.addPlayCount();
    },
    onClosedStream() {
      for (const name in this.dbRefs) {
        this.dbRefs[name].off();
      }
      firebase.database().goOffline();
      this.$store.dispatch('changeFirebaseState', false);
      window.removeEventListener('beforeunload', this.$_beforeunloadHandler);
      this.isOffline = true;
      this.isClosedStream = true;
    },
    async deletePost() {
      const message = (!this.postDetails.playingTime ? '配信が終了していません。\n' : '') + '投稿を削除しますか？';
      if (!await this.$refs.confirm.open(message, '削除', 'error')) {
        return;
      }
      try {
        await firebase.firestore()
          .collection('users').doc(this.$_myUserData.uid)
          .collection('posts').doc(this.postDetails.postId).delete();
        this.postDetails = {};
        await this.getPostDetails();
        this.$_pushNotice('投稿の削除に成功しました。', 'success');
      } catch (err) {
        console.error(err);
        this.$_pushNotice('投稿の削除に失敗しました。', 'error');
      }
    },
    async doFavPost() {
      const favPostRef = firebase.firestore()
        .collection('users').doc(this.$_myUserData.uid)
        .collection('favPosts').doc(this.$route.params.postId);
      try {
        if (this.postDetails.isFavorite) {
          await favPostRef.delete();
          this.postDetails.isFavorite = false;
          this.postDetails.favCount--;
          return;
        }
        await favPostRef.set({
          postId: this.postDetails.postId,
          postDetails: this.postDetails,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        });
        this.postDetails.isFavorite = true;
        this.postDetails.favCount++;
      } catch (err) {
        console.error(err);
        this.$_pushNotice('エラーが発生しました。', 'error');
      }
    },
    sharePost() {
      const title = this.postDetails.title + ' - midies';
      const url = 'https://midies.web.app/post/' + this.postDetails.postId;
      this.$refs.share.open(title, url);
    },
    async addPlayCount() {
      if (!localStorage) {
        return;
      }
      const nowTime = this.$_getNowTime(this.ntpTimeDiff);
      const oldTime = localStorage.getItem(this.postDetails.postId);
      if (nowTime - oldTime < 60*60*24*1000) {
        return;
      }
      const postRef = firebase.firestore()
        .collection('users').doc(this.postDetails.uid)
        .collection('posts').doc(this.postDetails.postId);
      await postRef.set({
        playCount: firebase.firestore.FieldValue.increment(1)
      }, { merge: true })
        .then(() => {
          localStorage.setItem(this.postDetails.postId, nowTime);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
